import { DashboardAppointment } from "../../../features/appointment/dashboardAppointment";
import { ApiAppointment } from "../../../core/apis/appointment";
import { useAppDispatch } from "../../../core/redux/ReduxStore";
import { useEffect } from "react";
import {
  ActionsPatientTable,
  appointmentCalendarActions,
} from "../../../core/redux";
import useSWR from "swr";
import { ApiResponseContainer } from "../../../models/api";
import { ApiSchemaAdminDashboard } from "../../../models/api/apiAdminDashboard";
import { AppRouteApi, AppRouteUi } from "../../../config/appRoute";
import { AxiosAuth } from "../../../core/axios";
import { Loader } from "rsuite";
import patientDashboardIcon from "../../../assets/img/dashbord-icon-05.svg";
import caregiverDashboardIcon from "../../../assets/img/Upload-Photo-caregiver.svg";
import appointmentsDashboardIcon from "../../../assets/img/dashbord-icon-02.svg";
import earningDashboardIcon from "../../../assets/img/dashbord-icon-04.svg";
import { useHistory } from "react-router-dom";
import { EnumPatientStatus } from "../../../libs";
import { convertToTwoDecimal } from "../../../utils/convertToTwoDecimal";

export function PageDashboard(): JSX.Element {
  const { data } = ApiAppointment.ByDateRange.Hook();
  const dispatch = useAppDispatch();
  const routeHistory = useHistory();

  useEffect(() => {
    data && dispatch(appointmentCalendarActions.setData(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const { data: apiAdminDashboardData, isValidating: apiDashboardValidating } =
    useSWR(AppRouteApi.Dashboard.Admin(), async () => {
      const response = await AxiosAuth.get<
        ApiResponseContainer<ApiSchemaAdminDashboard>
      >(AppRouteApi.Dashboard.Admin());
      return response.data.data;
    });

  const isLoadingAdminDashboard = apiDashboardValidating && !!data;

  return (
    <>
      <section>
        <div className="row gx-0 g-md-3 g-lg-3">
          <div className="col-xxxl-2 col-xxl-2 col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
            <div className="content-box bg-lighten-orange counter-box">
              <div className="d-flex align-items-center justify-content-between flex-grow-1">
                <div className="dash-box-icon flex-shrink-0">
                  <img
                    src={patientDashboardIcon}
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div className="dash-box-info text-capitalize ">
                  <div className="info-counter">
                    {isLoadingAdminDashboard ? (
                      <Loader size="sm" />
                    ) : (
                      <p>{apiAdminDashboardData?.patients}</p>
                    )}
                  </div>
                  <div className="info-title">
                    <p>Patients</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxxl-2 col-xxl-2 col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
            <div className="content-box bg-lighten-orange counter-box">
              <div className="d-flex align-items-center justify-content-between flex-grow-1">
                <div className="dash-box-icon flex-shrink-0">
                  <img
                    src={caregiverDashboardIcon}
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div className="dash-box-info text-capitalize ">
                  <div className="info-counter">
                    {isLoadingAdminDashboard ? (
                      <Loader size="sm" />
                    ) : (
                      <p>{apiAdminDashboardData?.caregivers}</p>
                    )}
                  </div>
                  <div className="info-title">
                    <p>Caregivers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxxl-2 col-xxl-2 col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
            <div className="content-box bg-lighten-red counter-box">
              <div className="d-flex align-items-center justify-content-between flex-grow-1">
                <div className="dash-box-icon flex-shrink-0">
                  <img
                    src={appointmentsDashboardIcon}
                    alt=""
                    className="img-fluid "
                  />
                </div>
                <div className="dash-box-info text-capitalize">
                  <div className="info-counter">
                    {isLoadingAdminDashboard ? (
                      <Loader size="sm" />
                    ) : (
                      <p>{apiAdminDashboardData?.appointments}</p>
                    )}
                  </div>
                  <div className="info-title">
                    <p>Appointments</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxxl-2 col-xxl-2 col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
            <div className="content-box bg-lighten-green  counter-box ">
              <div className="d-flex align-items-center justify-content-between flex-grow-1">
                <div className="dash-box-icon flex-shrink-0">
                  <img
                    src={earningDashboardIcon}
                    alt=""
                    className="img-fluid "
                  />
                </div>
                <div className="dash-box-info text-capitalize">
                  <div className="info-counter">
                    {isLoadingAdminDashboard ? (
                      <Loader size="sm" />
                    ) : (
                      <p>${convertToTwoDecimal(apiAdminDashboardData?.totalPaid!)}</p>
                    )}
                  </div>
                  <div className="info-title">
                    <p>Caregiver Payment</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxxl-2 col-xxl-2 col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
            <div className="content-box bg-lighten-blue  counter-box ">
              <div className="d-flex align-items-center justify-content-between flex-grow-1">
                <div className="dash-box-icon flex-shrink-0">
                  <img
                    src={earningDashboardIcon}
                    alt=""
                    className="img-fluid "
                  />
                </div>
                <div className="dash-box-info text-capitalize">
                  <div className="info-counter">
                    {isLoadingAdminDashboard ? (
                      <Loader size="sm" />
                    ) : (
                      <p>${convertToTwoDecimal(apiAdminDashboardData?.totalReceived!)}</p>
                    )}
                  </div>
                  <div className="info-title">
                    <p>Patient Payment</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxxl-2 col-xxxl-2 col-xxl-2 col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
            <div className="content-box bg-lighten-green  counter-box ">
              <div className="d-flex align-items-center justify-content-between flex-grow-1">
                <div className="dash-box-icon flex-shrink-0">
                  <img
                    src={earningDashboardIcon}
                    alt=""
                    className="img-fluid "
                  />
                </div>
                <div className="dash-box-info text-capitalize">
                  <div className="info-counter">
                    {isLoadingAdminDashboard ? (
                      <Loader size="sm" />
                    ) : (
                      <p>
                        {apiAdminDashboardData?.balance! < 0 ? (
                          <span className="text-danger">
                            ($ {convertToTwoDecimal(Math.abs(apiAdminDashboardData?.balance!))})
                          </span>
                        ) : (
                          <span>$ {convertToTwoDecimal(apiAdminDashboardData?.balance!)}</span>
                        )}
                      </p>
                    )}
                  </div>
                  <div className="info-title">
                    <p>Earnings</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {(apiAdminDashboardData?.serviceAuthorizationExpiredPatients! > 0 ||
        apiAdminDashboardData?.patientsServiceAuthorizationWillExpireWithinAWeek! >
          0 ||
        apiAdminDashboardData?.expiredCaregiverCertificateCount! > 0) && (
        <section className="alert alert-warning text-capitalize" role="alert">
          {apiAdminDashboardData?.serviceAuthorizationExpiredPatients! > 0 && (
            <p>
              <b
                onClick={() => {
                  dispatch(
                    ActionsPatientTable.setStatus(EnumPatientStatus.Expired)
                  );
                  routeHistory.push({
                    pathname: AppRouteUi.Patient.List(),
                    state: { status: "Expired" },
                  });
                }}
                className="click"
              >
                {apiAdminDashboardData?.serviceAuthorizationExpiredPatients}
              </b>{" "}
              Patients' service authorization date has been expired.{" "}
            </p>
          )}
          {apiAdminDashboardData?.patientsServiceAuthorizationWillExpireWithinAWeek! >
            0 && (
            <p>
              <b>
                {
                  apiAdminDashboardData?.patientsServiceAuthorizationWillExpireWithinAWeek
                }
              </b>{" "}
              Patients' service authorization date will be expired within a
              week.
            </p>
          )}
          {apiAdminDashboardData?.expiredCaregiverCertificateCount! > 0 && (
            <p>
              <b
                onClick={() => {
                  routeHistory.push({
                    pathname: AppRouteUi.Caregiver.List(),
                    state: { status: "Expired" },
                  });
                }}
                className="click"
              >
                {apiAdminDashboardData?.expiredCaregiverCertificateCount}
              </b>{" "}
              Caregivers' certificate has been expired.{" "}
            </p>
          )}
        </section>
      )}
      <section className="py-1 ">
        <DashboardAppointment data={data} />
      </section>
    </>
  );
}
